import React, { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Person } from '@mui/icons-material';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewText from '../ReviewText';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import ReviewFooter from '../ReviewFooter';

interface Props extends IReviewNewProps {}

const EKomiReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  const { username, text, rating, companyComment } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1), mb: theme.spacing(2) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      <ReviewText text={text} />
    </ReviewWrapper>
  );
};

export default EKomiReview;
